export default {
  en : {
    weekNames   : ['Sun', 'Mon','Tue','Wed','Thu','Fri','Sat'],
    monthNames  : ['January','February','March','April','May','June','July','August','September','October','November','December'],
    titleFormat : 'MMMM yyyy'
  },
  zh : {
    weekNames   : ['周日', '周一','周二','周三','周四','周五','周六'],
    monthNames  : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    titleFormat : 'yyyy年MM月'
  },
  fr : {
    weekNames   : ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'],
    monthNames  : ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
    titleFormat : 'MMMM yyyy'
  }
}



// WEBPACK FOOTER //
// ./src/topdoor/components/calendar/dataMap/langSets.js